module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0044.png.fa2ea878.jpg";